/* @flow */
import type { Action } from "../action";

type State = * | null;

function apiCountries(state: State = null, action: Action): State {
  switch (action.type) {
    case "RECEIVE_API_COUNTRIES":
      return action.payload;
    default:
      return state;
  }
}

export default apiCountries;



// WEBPACK FOOTER //
// ./src/redux/reducer/apiCountries.js